import { isEducadorDigitalPlan } from '@/utils/educadorDigitalPlan';

/**
 * Resolve a home do professor considerando:
 * 1) Preferência + feature flag do novo dashboard (backend)
 * 2) Plano Educador Digital
 * 3) Início legado
 */
export function resolveTeacherHomePath(user, dashboardPrefs) {
    if (dashboardPrefs?.isNewDashboardActive) {
        return '/dashboard';
    }
    if (isEducadorDigitalPlan(user)) {
        return '/dashboard-educador-digital';
    }
    return '/';
}

/**
 * Quando o redirect pós-login é a raiz, aplica a mesma regra de home.
 */
export function resolvePathWhenRedirectIsRoot(redirectPath, user, dashboardPrefs) {
    const raw = typeof redirectPath === 'string' && redirectPath.trim() ? redirectPath.trim() : '/';
    let pathOnly = raw;
    const q = raw.indexOf('?');
    if (q !== -1) pathOnly = raw.slice(0, q);
    if (pathOnly === '/' || pathOnly === '') {
        return resolveTeacherHomePath(user, dashboardPrefs);
    }
    return raw;
}
